import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { getActiveVariant } from '../../helpers.js';
import { pushPdpEventToDataLayer } from '../../utils/DataLayer/data-layer.js';
import Accessories$1 from './Accessories.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const AccessoriesContainer = ({ activeSku , addToCartRef , dispatch , formatProductUrl , handleConversionEvent , onCTAClick , product , productImageGallery , productTypeUsps , showStickyButton , specificationConfiguration , stickyTop , variant , storesRoute  })=>{
    var ref;
    const { currency , getFormattedLabel , getLabel , locale  } = useIntl();
    const brandLink = useBrandLink(product);
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const activeVariant = getActiveVariant(product, activeSku);
    getLocalizedValue(product.name, locale);
    var ref1;
    const stockCount = (ref1 = (ref = variant.availability) === null || ref === void 0 ? void 0 : ref.availableQuantity) !== null && ref1 !== void 0 ? ref1 : 0;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const labels = React.useMemo(()=>({
            priceInformation: getLabel('products.screenreader.priceInformation')
        })
    , [
        getLabel,
        getFormattedLabel
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    return /*#__PURE__*/ React.createElement(Accessories$1, {
        activeSku: activeSku,
        activeVariant: activeVariant,
        dispatch: dispatch,
        addToCartRef: addToCartRef,
        brandLink: brandLink,
        currency: currency,
        formatProductUrl: formatProductUrl,
        handleConversionEvent: handleConversionEvent,
        isMobile: isMobile,
        isSmallScreen: isSmallScreen,
        isOrderable: isOrderable,
        labels: labels,
        locale: locale,
        onCTAClick: onCTAClick,
        product: product,
        productImageGallery: productImageGallery,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        specificationConfiguration: specificationConfiguration,
        stickyTop: stickyTop,
        stockCount: stockCount,
        variant: variant,
        variants: variants,
        storesRoute: storesRoute
    });
};
var Accessories = AccessoriesContainer;

export { Accessories as default };
//# sourceMappingURL=AccessoriesContainer.js.map
